import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from "antd";
// Shared content panel for the affiliate center — reuses the details-card chrome
// (same recipe as the "Your personal data" box and the subscription section
// cards): a headline + optional subhead in a divided head, content in the body,
// and the soft form-card box-shadow. Used for every dashboard panel and form
// section so the whole tab reads as one design language.
const AffiliatePanel = ({ heading, subline, action, children })=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs("section", {
        className: "rc-account-v2-details-card rc-account-v2-affiliate-panel",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-details-card__head rc-account-v2-affiliate-panel__head",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "rc-account-v2-details-card__heading",
                                style: {
                                    color: token.colorTextHeading
                                },
                                children: heading
                            }),
                            subline && /*#__PURE__*/ _jsx("p", {
                                className: "rc-account-v2-details-card__intro",
                                style: {
                                    color: token.colorTextSecondary
                                },
                                children: subline
                            })
                        ]
                    }),
                    action && /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-affiliate-panel__action",
                        children: action
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-details-card__body",
                children: children
            })
        ]
    });
};
export { AffiliatePanel };
